import dayjs from "dayjs"
import React from "react"
import {
  ACTIVITY_TYPE_ENUM, AREA_REGISTERED_ENUM,
  INSPECTION_STATUS_ENUM,
  INSPECTION_STATUS_STRING, PAYMENT_STATUS_ENUM, PAYMENT_STATUS_STRING, UNIT_STRING
} from "../../constants/StringConstant.js"
import { ICON_CONSTANTS } from "../../constants/ImageConstants.js"
import { BadgeStatus, Status } from "../../component/index.jsx"

export const objectString = (data, convert) => {
  if (!convert) {
    let newdata = []
    for (const key in data) {
      if (typeof data[key] === "object") {
        for (const kd in data[key]) {
          if (typeof data[key][kd] === "object") {
            for (const kdd in data[key][kd]) {
              newdata.push(
                encodeURIComponent(key) +
                "[" +
                encodeURIComponent(kd) +
                "]" +
                "[" +
                encodeURIComponent(kdd) +
                "]=" +
                encodeURIComponent(data[key][kd][kdd])
              )
            }
          } else {
            newdata.push(
              encodeURIComponent(key) +
              "[" +
              encodeURIComponent(kd) +
              "]=" +
              encodeURIComponent(data[key][kd])
            )
          }
        }
      } else {
        newdata.push(encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
      }
    }
    return "?" + newdata.join("&")
  } else {
    if (data) {
      data = data.replace("?", "")
      if (data) {
        data = data.split("&")
        let newdata = []
        for (const key in data) {
          let dk = data[key].split("=")
          let dkk = []
          dkk[decodeURIComponent(dk[0])] = decodeURIComponent(dk[1])
          newdata.push(dkk)
        }

        return newdata
      } else {
        return false
      }
    }
  }
}

export const toCapitalize = (str) => {
  if (!str) {
    return "-"
  } else if (typeof str !== "string") {
    return "Not Valid"
  }
  return str.charAt(0).toUpperCase() + str.slice(1)
}

export const getRoundUp = (estimated_land_area) => {
  if (!estimated_land_area) {
    return "-"
  } else {
    return Math.round(estimated_land_area)
  }
}

export const toMeter = (value) => {
  let result = toThousandConvert(value)
  return (
    <>
      {result}
      <span className={"text-lowercase"}>&nbsp;m</span>
      <sup>2</sup>
    </>
  )
}

export const toHectare = (value) => {
  let result = convertDotToComma(value)

  return (
    <>
      {result}
      <span>&nbsp;{UNIT_STRING.HA}</span>
    </>
  )
}

export const convertDigits = (value, digit) => {
  return parseFloat(value).toFixed(digit)
}

export const toThousandConvert = (value) => {
  let result = value
  if (typeof value === "number") {
    const main = convertDigits(value, 2)
    result = new Intl.NumberFormat("id-ID").format(main)
  } else {
    const data = parseFloat(value)
    const main = convertDigits(data, 2)
    result = new Intl.NumberFormat("id-ID").format(main)
  }
  return result
}

export const toRupiah = (value) => {
  if (typeof value !== "number" || !isFinite(value)) {
    return "-"
  }
  const options = {
    style: "currency",
    currency: "IDR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }
  return new Intl.NumberFormat("id-ID", options)
    .format(value)
    .replace(/\u00a0/g, "")
}


export function toLocaleString(num) {
  if (num) {
    return num.toLocaleString("id-ID")
  } else if (num === 0) {
    return "0"
  } else {
    return "0"
  }
}

export function thousandSeparator(num) {
  return toLocaleString(num ?? 0)
}

export const bytesToMegaBytes = (value, type) => {
  const main = value / 1024 ** 2
  const int = main.toFixed(2)
  const result = int
  if (type === true) {
    return result + " Mb"
  } else {
    return result
  }
}

export const bytesToKiloBytes = (value, type) => {
  const main = value / 1024
  const int = main.toFixed(2)
  const result = int
  if (type === true) {
    return result + " Kb"
  } else {
    return result
  }
}

export const fileTypeSplit = (name) => {
  const file = name.split(".").reverse()[0]
  if (file === "pdf") {
    return "application/pdf"
  } else if (file === "png") {
    return "image/png"
  } else if (file === "jpg") {
    return "image/jpg"
  } else if (file === "jpeg") {
    return "image/jpeg"
  } else {
    return "Not Valid"
  }
}

export const titleCase = (str) => {
  var splitStr = str.toLowerCase().split(" ")
  for (var i = 0; i < splitStr.length; i++) {
    splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1)
  }
  return splitStr.join(" ")
}

export const handleSpace = (e) => {
  if (e.currentTarget.value === "" || e.target.selectionStart === 0) {
    e.keyCode === 32 && e.preventDefault()
  }
}

export const dateFormat = (date, format) => {
  return dayjs(date).format(format)
}

export const convertM2ToHectare = (num, fix) => {
  return (num / 10000).toFixed(fix || 2)
}

export const convertM2ToHectareParseFloat = (num, fix) => {
  const result = num / 10000
  if (result % 1 === 0) {
    return result.toFixed(0) // Tampilkan tanpa koma
  } else {
    const formatted = parseFloat(result.toFixed(fix || 4))
    return formatted.toString()
  }
}

export const stringFormatting = (param, suffix) => {
  if (Array.isArray(param) && param?.length === 0) return "-"
  else if (Array.isArray(param) && param?.length > 0) return param.join(", ")
  else if (param === null) return "-"
  else if (param === "") return "-"
  else if (param === undefined) return "-"
  else return param + (suffix ? " " + suffix : "")
}

export function parseThousandSeparatorToNumber(num) {
  return parseInt(num.replace(/\./g, ""))
}

export const checkCommaInDataPic = (index, length) => {
  if (length > 1 && index === 0) {
    return true
  } else if (length === 1) {
    return false
  } else if (length > 2) {
    return true
  } else if (length === 2 && index === 1) {
    return false
  }
}

export const convertDotToComma = (value, suffix) => {
  return stringFormatting(value?.toString().replace(".", ","), suffix)
}

export const convertDotToCommaZero = (value, suffix) => {
  if (value === 0) {
    return "0" + (suffix ? " " + suffix : "")
  }
  if (value === null || value === undefined || value === "") {
    return "-"
  }
  return value.toString().replace(".", ",") + (suffix ? " " + suffix : "")
}

export const toKilogram = (value, convert = true) => {
  let result = convert ? toThousandConvert(value) : value
  return (
    <>
      {result}
      <span>&nbsp;Kg</span>
    </>
  )
}

export const isEmptyObj = (obj) => {
  for (var key in obj) {
    if (obj.hasOwnProperty(key)) return false
  }
  return true
}

export const findFirst = (array) => {
  return array.find(Boolean)
}

export const checkDateRangeValue = (start_date, end_date) => {
  if (start_date && end_date) {
    return start_date + " s/d " + end_date
  } else {
    return "-"
  }
}

//QA ACTIVITY FUNCTION

export const checkActivityIcon = (data) => {
  switch (data) {
    case ACTIVITY_TYPE_ENUM.PRELIMINARY:
      return ICON_CONSTANTS.QA_ACTIVITY.PRELIMINARY
    case ACTIVITY_TYPE_ENUM.VEGETATIVE:
      return ICON_CONSTANTS.QA_ACTIVITY.VEGETATIVE
    case ACTIVITY_TYPE_ENUM.FLOWERING:
      return ICON_CONSTANTS.QA_ACTIVITY.FLOWERING
    case ACTIVITY_TYPE_ENUM.RIPE:
      return ICON_CONSTANTS.QA_ACTIVITY.RIPE
    case ACTIVITY_TYPE_ENUM.HARVEST:
      return ICON_CONSTANTS.QA_ACTIVITY.HARVEST
  }
}

export const checkStatus = (status) => {
  switch (status) {
    case INSPECTION_STATUS_ENUM.PASS:
      return <Status text={INSPECTION_STATUS_STRING[status]} variant={"approved"} />
    case INSPECTION_STATUS_ENUM.NOT_PASS:
      return <Status text={INSPECTION_STATUS_STRING[status]} variant={"danger"} />
    case INSPECTION_STATUS_ENUM.PARTIAL_PASS:
      return <Status text={INSPECTION_STATUS_STRING[status]} variant={"warning"} />
  }
}

export const checkActivityName = (data) => {
  switch (data) {
    case ACTIVITY_TYPE_ENUM.PRELIMINARY:
      return "label_preliminary_inspection"
    case ACTIVITY_TYPE_ENUM.VEGETATIVE:
      return "label_vegetative_inspection"
    case ACTIVITY_TYPE_ENUM.FLOWERING:
      return "label_flowering_inspection"
    case ACTIVITY_TYPE_ENUM.RIPE:
      return "label_ripe_inspection"
    case ACTIVITY_TYPE_ENUM.HARVEST:
      return "label_harvest_inspection"
  }
}

export const checkBadge = (status, className) => {
  const variant = (data) => {
    switch (data) {
      case INSPECTION_STATUS_ENUM.PASS:
        return "success"
      case INSPECTION_STATUS_ENUM.NOT_PASS:
        return "danger"
      case INSPECTION_STATUS_ENUM.PARTIAL_PASS:
        return "warning"
      case INSPECTION_STATUS_ENUM.LAND_CLEARING:
        return "light"
      default:
        return "secondary" // Default variant if status is undefined
    }
  }
  return (
    <BadgeStatus
      className={className ?? "w-130px"}
      variant={variant(status)}
      status={INSPECTION_STATUS_STRING[status]}
    />
  )
}

export const checkBadgePaymentStatus = (status, className) => {
  const variant = (data) => {
    switch (data) {
      case PAYMENT_STATUS_ENUM.PAID:
        return "primary"
      case PAYMENT_STATUS_ENUM.PARTIALLY_PAID:
        return "warning"
      case PAYMENT_STATUS_ENUM.NOT_PAID:
        return "danger"
      case PAYMENT_STATUS_ENUM.NON_BILL:
        return "secondary"
      default:
        return "primary" // Default variant if status is undefined
    }
  }
  return (
    <BadgeStatus
      className={className ?? "mr-4 w-98px h-26px"}
      variant={variant(status)}
      status={PAYMENT_STATUS_STRING[status]}
    />
  )
}

export const getDueDateText = (dueDate) => {
  if (dueDate > 0) {
    return `${dueDate} Hari Lagi`
  }

  if (dueDate === 0) {
    return 'Hari ini'
  }
  
  if (dueDate < 0) {
    return `${Math.abs(dueDate)} Hari Terlewat`
  }
 
  return null
}

export const checkAreaRegisteredValue = (value) => {
  return [
    AREA_REGISTERED_ENUM.MT_ACTIVE,
    AREA_REGISTERED_ENUM.LAND_NEW,
    AREA_REGISTERED_ENUM.MT_COMPLETED].includes(value)
}